module.exports = __webpack_public_path__ + "img/14-s.3ee93e99.png";